module.exports = __webpack_public_path__ + "img/screen-exit.c369da00.jpg";